/**
 * Предел длительности голосового сообщения — 10 минут (отзыв #451). Та же константа живёт в
 * KMP (`VOICE_MAX_MS` в `VoiceRecorder.kt`) и на Desktop: поведение должно совпадать во всех
 * клиентах, иначе длинную запись в одном клиенте нельзя повторить в другом.
 *
 * Причина предела: голосовое целиком уходит в память и на сервер (в KMP — ещё и в память
 * устройства), а десятиминутная запись не нужна и на практике обрывается блокировкой экрана.
 */
export const VOICE_MAX_MS = 10 * 60 * 1000;

/** Сколько осталось до автостопа; 0 — лимит уже достигнут. */
export function voiceRemainingMs(elapsedMs: number): number {
  return Math.max(0, VOICE_MAX_MS - elapsedMs);
}

/** Пора останавливать запись автоматически. */
export function isVoiceLimitReached(elapsedMs: number): boolean {
  return elapsedMs >= VOICE_MAX_MS;
}

/** «0:07 / 10:00» — сколько идёт запись и её предел (без новых строк перевода). */
export function formatRecordingLimit(elapsedMs: number, limitMs: number = VOICE_MAX_MS): string {
  return `${formatClock(elapsedMs)} / ${formatClock(limitMs)}`;
}

function formatClock(ms: number): string {
  const total = Math.max(0, Math.floor(ms / 1000));
  const minutes = Math.floor(total / 60);
  const seconds = total % 60;
  return `${minutes}:${String(seconds).padStart(2, '0')}`;
}
